'use client';

import Box, { type BoxProps } from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

const contentColumnSx = {
  marginInline: 'auto',
  maxWidth: { xs: '100%', md: '1152px' },
  paddingX: { xs: 3, lg: 0 },
} as const;

const articleGridSx = {
  display: 'grid',
  gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
  columnGap: 2,
  rowGap: 4,
  marginBottom: 4,
} as const;

const contentCellSx = {
  gridColumn: { xs: 'span 12', sm: 'span 8' },
} as const;

const calculatorCellSx = {
  gridColumn: 'span 12',
} as const;

const headerBelowHeadingSx = {
  '&& :is(h1, h2, h3, h4, h5, h6)': {
    typography: 'titleSmall',
  },
} as const;

function mergeSx(base: SxProps<Theme>, sx: BoxProps['sx']): SxProps<Theme> {
  return [base, ...(Array.isArray(sx) ? sx : [sx])];
}

export function ContentColumn({ sx, ...props }: BoxProps) {
  return <Box {...props} sx={mergeSx(contentColumnSx, sx)} />;
}

export function ArticleGrid({ sx, ...props }: BoxProps) {
  return <ContentColumn {...props} sx={mergeSx(articleGridSx, sx)} />;
}

export function ContentCell({ sx, ...props }: BoxProps) {
  return <Box {...props} sx={mergeSx(contentCellSx, sx)} />;
}

export function CalculatorCell({ sx, ...props }: BoxProps) {
  return <Box {...props} sx={mergeSx(calculatorCellSx, sx)} />;
}

export function HeaderBelowHeading({ sx, ...props }: BoxProps) {
  return <ContentCell {...props} sx={mergeSx(headerBelowHeadingSx, sx)} />;
}
